import type { Snapshot, ItemSlot } from '../types';
import { normalizeEquipment } from './wow';

/**
 * Slots that count toward the "average iLvl" calculation. Following the
 * Blizzard convention used in WotLK: shirt (4) and tabard (19) are
 * excluded; ranged (18) is included for the classes that use it.
 *
 * NOTE: At time of writing the snapshot does NOT carry per-item iLvl
 * (the addon does not call GetItemInfo for equipped slots). This module
 * is wired so that as soon as `itemLevel` lands on `ItemSlot`, the UI
 * lights up automatically. Until then `averageItemLevel()` returns null.
 *
 * TODO(addon): record `itemLevel` per slot in HeroExtract.lua and the
 * watcher's LuaParser so this can render real values.
 */
const COUNTED_SLOTS = new Set<number>([
  1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
]);

export function averageItemLevel(snapshot: Snapshot): number | null {
  const eq = normalizeEquipment(snapshot.equipment);
  const items = Object.values(eq) as ItemSlot[];
  const lvls: number[] = [];
  for (const it of items) {
    if (!it || typeof it.slot !== 'number') continue;
    if (!COUNTED_SLOTS.has(it.slot)) continue;
    const lv = (it as any).itemLevel;
    if (typeof lv === 'number' && lv > 0) lvls.push(lv);
  }
  if (lvls.length === 0) return null;
  return Math.round(lvls.reduce((a, b) => a + b, 0) / lvls.length);
}
